var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c("h2", { staticClass: "card__title" }, [_vm._v(" 輸入捐款人資訊 ")]),
      _c("hr"),
      _c("FormRow", [
        _c(
          "div",
          { class: _vm.$style.formControl },
          [
            _c("FormLabel", [_vm._v(" 捐款人姓氏 ")]),
            _c("TextInput", {
              attrs: {
                id: "lastName",
                value: _vm.form.lastName,
                autocomplete: "family-name",
                placeholder: "請輸入捐款人姓氏",
              },
              on: {
                "update:value": function ($event) {
                  return _vm.$set(_vm.form, "lastName", $event)
                },
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { class: _vm.$style.formControl },
          [
            _c("FormLabel", [_vm._v(" 捐款人名字 ")]),
            _c("TextInput", {
              attrs: {
                id: "firstName",
                value: _vm.form.firstName,
                autocomplete: "given-name",
                placeholder: "請輸入捐款人名字",
              },
              on: {
                "update:value": function ($event) {
                  return _vm.$set(_vm.form, "firstName", $event)
                },
              },
            }),
          ],
          1
        ),
      ]),
      _c("FormRow", [
        _c(
          "div",
          { class: _vm.$style.formControl },
          [
            _c("FormLabel", [_vm._v(" 捐款人手機號碼 ")]),
            _c("TextInput", {
              attrs: {
                id: "tel",
                value: _vm.form.tel,
                inputmode: "tel",
                autocomplete: "tel",
                placeholder: "請輸入捐款人手機號碼",
                error: _vm.phoneNumberError,
              },
              on: {
                "update:value": function ($event) {
                  return _vm.$set(_vm.form, "tel", $event)
                },
              },
            }),
            _c(
              "Button",
              {
                attrs: {
                  small: "",
                  disabled: !_vm.isAllowSendVerificationCode,
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.sendVerificationCode.apply(null, arguments)
                  },
                },
              },
              [
                _vm.isFetching
                  ? _c("LoadingDots", { attrs: { theme: `white` } })
                  : [
                      _vm._v(" 傳送驗證碼 "),
                      _vm.countdownSeconds > 0
                        ? _c("span", [
                            _vm._v(" (" + _vm._s(_vm.countdownSeconds) + "s) "),
                          ])
                        : _vm._e(),
                    ],
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("FormRow", { attrs: { center: "" } }, [
        _c(
          "div",
          { class: [_vm.$style.formControl] },
          [
            _c("FormLabel", [_vm._v(" 驗證碼 ")]),
            _c("TextInput", {
              attrs: {
                id: "verificationCode",
                value: _vm.form.verificationCode,
                autocomplete: "one-time-code",
                placeholder: "請輸入驗證碼",
              },
              on: {
                "update:value": function ($event) {
                  return _vm.$set(_vm.form, "verificationCode", $event)
                },
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "Align",
        { attrs: { center: "" } },
        [
          _c(
            "RouterLink",
            { attrs: { to: "/search" } },
            [
              _c("Button", { attrs: { transparent: "" } }, [
                _vm._v(" 上一步 "),
              ]),
            ],
            1
          ),
          _c(
            "Button",
            {
              nativeOn: {
                click: function ($event) {
                  return _vm.search.apply(null, arguments)
                },
              },
            },
            [_vm._v(" 查詢 ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }